import Shift from './shift'

class TimeRegistrationShift extends Shift {
	static defaultJoins = ['users', 'teams']
	static tableName = 'timeRegistrationShifts'
	static improductiveTypes = ['verlof', 'bijzonder_verlof', 'ziek']
	static types = ['gewerkte_uren', ...this.improductiveTypes]

	isImproductive() {
		return this.constructor.improductiveTypes.includes(this.typ)
	}

	improductiveType() {
		if (this.typ === 'verlof') return 'leave'
		if (this.typ === 'bijzonder_verlof') return 'special_leave'
		if (this.typ === 'ziek') return 'sick'
		return null
	}

	relevantForWage() {
		return this.typ != 'verlof'
	}

	static useUnproductive(params, opts) {
		const prms = {typ: this.improductiveTypes, ...params}
		return super.useWhere(prms, opts)
	}
}

export default TimeRegistrationShift
